import { Logger } from "@devforce/trailhead-client-logger";
import { getAccessToken } from "@devforce/trailhead-client-auth";
export const PACKAGE_NAME = "@devforce/trailhead-client-fetch";
export const logger = new Logger({
    prefix: `[${PACKAGE_NAME}]: `,
});
export async function fetch(url, init = {}) {
    let request = await state.middlewares.reduce((request, { name, handleRequest }) => {
        return handleRequest
            ? request.then((request) => {
                logger.info(`Running handleRequest() for: "${name}"`);
                return handleRequest(request);
            })
            : request;
    }, Promise.resolve({ url, init }));
    return window.fetch(request.url, { ...request.init }).then((response) => {
        return state.middlewares.reduce((response, { name, handleResponse }) => {
            return handleResponse
                ? response.then((response) => {
                    logger.info(`Running handleResponse() for: "${name}"`);
                    return handleResponse(response, request);
                })
                : response;
        }, Promise.resolve(response));
    });
}
export async function fetchJSON(url, { headers, ...options } = {}) {
    const token = await getAccessToken();
    let response = await fetch(url, {
        ...options,
        headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...headers,
            Accept: "application/json; charset=utf-8",
        },
    });
    if (response.ok)
        return response.json();
    if (/json/.test(String(response.headers.get("Content-Type"))))
        return response.json().then((errorJSON) => Promise.reject(errorJSON));
    throw new Error(`Application error code ${response.status} for "${url}"`);
}
export { fetchJSON as getJSON };
export function postJSON(url, body, { headers, method = "POST", ...options } = {}) {
    return fetchJSON(url, {
        ...options,
        method,
        headers: {
            ...headers,
            "Content-Type": "application/json; charset=utf-8",
        },
        body: typeof body === "string" ? body : JSON.stringify(body),
    });
}
export function registerMiddleware(middleware) {
    let names = new Set(state.middlewares.map((m) => m.name));
    if (names.has(middleware.name)) {
        throw new Error(`Middleware with name "${middleware.name}" is already registered`);
    }
    state.middlewares.push(middleware);
    return () => {
        state.middlewares = state.middlewares.filter((m) => m !== middleware);
    };
}
let state = {
    middlewares: [],
};
export function initializeState(currentState, existingState) {
    return existingState !== null && existingState !== void 0 ? existingState : currentState;
}
// This module may be executed multiple times from different sources
if (typeof window !== "undefined") {
    // @ts-ignore
    state = window[PACKAGE_NAME] = initializeState(state, window[PACKAGE_NAME]);
}
